import { render, staticRenderFns } from "./TeachingCourseScheduleModal.vue?vue&type=template&id=2d03ded8&scoped=true"
import script from "./TeachingCourseScheduleModal.vue?vue&type=script&lang=js"
export * from "./TeachingCourseScheduleModal.vue?vue&type=script&lang=js"
import style0 from "./TeachingCourseScheduleModal.vue?vue&type=style&index=0&id=2d03ded8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03ded8",
  null
  
)

export default component.exports